module.exports = __webpack_public_path__ + "static/media/helvetica-bold-font-webfont.510bf521.woff";